export * from './profile-user-role.details.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/profile-user/profile-user-role-details/index.ts